// The CRM section's copy (Admin → CRM, docs/crm-module/crm-frontend-design.md §H): one
// fragment per screen family, merged here. Every CRM component binds its own
// `const t = useT("crm")`.
import { mergeFragments } from "../../mergeFragments";
import common from "./common";
import errors from "./errors";
import dashboard from "./dashboard";
import nudges from "./nudges";
import performance from "./performance";
import clients from "./clients";
import filters from "./filters";
import detail from "./detail";
import booking from "./booking";
import privacy from "./privacy";
import timeline from "./timeline";
import importWizard from "./import";
import enums from "./enums";
// crm-module BEGIN C2.03/C2.04 (lane F2)
import packs from "./packs";
import forms from "./forms";
// crm-module END
// crm-module BEGIN C2.05 (lane F1)
import email from "./email";
import sequenceEditor from "./sequenceEditor";
import broadcast from "./broadcast";
// crm-module END
// Email preview (owner decision 2026-10-21)
import emailPreview from "./emailPreview";
// crm-module BEGIN C3.02 (lane F5)
import team from "./team";
// crm-module END
// crm-module BEGIN C3.02/C3.04 (lane F4)
import promote from "./promote";
// crm-module END
// crm-module BEGIN CR-F3-1
import settings from "./settings";
// crm-module END
// Owner decision 2026-10-21: delete from the Clients list.
import clientDelete from "./clientDelete";

export default mergeFragments([
  common, errors, dashboard, nudges, performance, clients, filters, detail, booking, privacy, timeline, importWizard, enums,
  // crm-module BEGIN C2.03/C2.04 (lane F2)
  packs, forms,
  // crm-module END
  // crm-module BEGIN C2.05 (lane F1)
  email, sequenceEditor, broadcast,
  // crm-module END
  // Email preview (owner decision 2026-10-21)
  emailPreview,
  // crm-module BEGIN C3.02 (lane F5)
  team,
  // crm-module END
  // crm-module BEGIN C3.02/C3.04 (lane F4)
  promote,
  // crm-module END
  // crm-module BEGIN CR-F3-1
  settings,
  // crm-module END
  clientDelete,
]);
